import { NgClass, NgStyle } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  DestroyRef,
  effect,
  forwardRef,
  inject,
  input,
  output,
} from '@angular/core';
import {
  AbstractControl,
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Label } from '../label/label';

import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { InputError } from '../input-error/input-error';
import { LocalizationService } from '../../../core/services/localization/localization.service';

@Component({
  selector: 'smm-text-input',
  imports: [TranslatePipe, ReactiveFormsModule, FormsModule, NgClass, Label, InputError],
  templateUrl: './text-input.html',
  styleUrls: ['./text-input.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => TextInput),
      multi: true,
    },
  ],
})
export class TextInput {
  private _cdr = inject(ChangeDetectorRef);
  private _destroyRef = inject(DestroyRef);

  onBlur = input<(event: FocusEvent) => void>(() => {});

  type = input('text');
  disabled = input(false);
  placeHolder = input('');
  required = input(true);
  formControlName: string = '';
  value = '';
  maxlength = input<string>('');
  control = input<AbstractControl>();
  customeError = input(false);
  customeClass = input('');
  formControl = input<FormControl>();
  valueChange = output<string>();

  // Label Inputs
  label = input('');
  labelIcon = input('');
  isOptional = input(false);

  isNewsletter = input(false);

  constructor(private localizationService: LocalizationService) {
    // Subscribe to control status changes to update the view when touched/validation status changes
    effect(() => {
      const ctrl = this.control();
      if (ctrl) {
        ctrl.statusChanges.pipe(takeUntilDestroyed(this._destroyRef)).subscribe(() => {
          this._cdr.markForCheck();
        });
      }
    });
  }

  onChange!: (event: any) => void;
  onTouched!: (event: any) => void;
  ngOnInit(): void {
    this.formControlName = this.getFormControlName(this.formControl())!;
  }

  get appDirection() {
    return this.localizationService.isArabic;
  }

  /* Set Input Value */
  writeValue(value: string): void {
    this.value = value ? value : '';
  }

  /* Set Value Changes */
  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  /* Detect Input Touch  */
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  handleBlur(event: FocusEvent): void {
    this.onTouched(event);
    this.onBlur()(event);
  }
  // /* Get Form Control Name From Form Group */
  getFormControlName(c: any) {
    const formGroup = c.parent.controls;
    return Object.keys(formGroup!)?.find((name: any) => c === formGroup[name]) || null;
  }

  detectValueChange(target: any): void {
    const value = target.value;
    if (value) {
      if (this.type() === 'number') {
        if (isNaN(value)) {
          this.formControl()?.setErrors({ notNumber: true });
        }
      } else {
        this.onChange(value);
      }
    } else {
      this.onChange('');
    }
    this.valueChange.emit(value);
  }
}
